import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { Select } from 'ionic-angular/components/select/select';
/**
 * Generated class for the IntervalPickerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'interval-picker',
  templateUrl: 'interval-picker.html'
})
export class IntervalPickerComponent {
  @ViewChild('intervalSelect') intervalSelect: Select;
  @Output('change') change: EventEmitter<string> = new EventEmitter<string>();

  interval: string = 'day';
  selectOptions = {
    title: 'Set Interval',
    subTitle: 'Select the time interval you want the charts to display.'
  }

  constructor() {

  }

  currencyChange(event: Event){
    // let loader = this.loadingCtrl.create();
    // loader.present();
    this.change.emit(this.interval);
  }

  openSelect(){
    this.intervalSelect.open();
  }

  intervals = [
    'day',
    'week',
    'month',
    '3month',
    'year'
  ]

  intervalMap = {
    'day': 'Day',
    'week': 'Week',
    'month': 'Month',
    '3month': '3 Month',
    'year': 'Year'
  }

  getIntervalText(interval): string{
    return this.intervalMap[interval];
  }
}



// WEBPACK FOOTER //
// ./src/components/interval-picker/interval-picker.ts